import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';

export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['sm'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'] }) {
    if (window?.SMSdk?.getDeviceId) return;
    const { url } = data
    const time = Date.now()
    // 使用本地临时数据
    let smDeviceId = window?.localStorage?.getItem('SmDeviceId') || ''
    window.__SmDeviceId = smDeviceId
    window?.sessionStorage?.setItem('SmDeviceId', smDeviceId)
    window?.sessionStorage?.setItem('SmDeviceIdAbt', 'true')
    window._smReadyFuncs = []
    window.SMSdk = { ready: (fn: any) => fn && window._smReadyFuncs.push(fn) }
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    })
        .then(() => {
            window?.SMSdk?.ready(() => {
                const smDeviceId = window?.SMSdk?.getDeviceId() || ''
                if (smDeviceId) {
                    window.__SmDeviceId = smDeviceId
                    window?.sessionStorage?.setItem('SmDeviceId', smDeviceId)
                    window?.localStorage?.setItem('SmDeviceId', smDeviceId)
                }
            })
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadSM' },
                value: Date.now() - time,
                message: 'smDeviceId load success',
            })
        }).then(() => {
            monitorSingleJsLoadTime('fpv', JS_SERVER_TYPE[extra.env][extra.server_type]);
        })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadSMError' },
                value: Date.now() - time,
                message: 'smDeviceId load error',
                params: error
            })
        })
}

export async function headerOpenController(self: XMLHttpRequest, url: string) {
    if (GlobalVariables.get(GLOBAL_VARIABLES.API_PATHS).some(path => url.includes(path))) {
        const at = window.__SmDeviceId || window?.sessionStorage?.getItem('SmDeviceId') || window?.localStorage?.getItem('SmDeviceId') || ''
        self._customHeaders = {
            ...self._customHeaders,
            'smDeviceId': at
        };
    }
}

export async function headerSendController(self: XMLHttpRequest) {
    if (self?._customHeaders?.['smDeviceId']) {
        self.setRequestHeader('smDeviceId', self?._customHeaders?.['smDeviceId']);
    }
}

export async function provideSmdeviceid() {
    const time = Date.now();
    try {
        if (!window?.Wing) return ''
        const res = await window?.Wing?.postBridge('WingHeader/get') || {};
        const headers = res?.headers || {};
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadSM', url: 'shein' },
            value: Date.now() - time,
            message: 'smDeviceId load success',
        })
        return headers['SmDeviceId'] || ''
    } catch (error) {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadSMError', url: 'shein' },
            value: Date.now() - time,
            message: 'smDeviceId load error',
            params: error
        })
    }
    return ''
}